import React from "react";
import Graph from "./Graph";
import "./App.css";

function App() {
    return (
        <Graph />
    );
}

export default App;
